import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { CriteriaDirection, CriteriaDirectionSchema } from '../../../enumerations/CriteriaDirection';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedArtifactResource,
    IndirectlyVersionedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';
import { IdSchema } from '../../../resource-base/baseSchemas';

export enum ProcessAreaCriteriaAssociationPropertyValidation {
    CRITERIA = 'CRITERIA',
    DIRECTION = 'DIRECTION',
}

export const ProcessAreaCriteriaAssociationResourceSchema = IndirectlyVersionedArtifactResourceSchema.extend({
    resourceType: z
        .literal(ResourceType.PROCESS_AREA_CRITERIA_ASSOCIATION)
        .default(ResourceType.PROCESS_AREA_CRITERIA_ASSOCIATION),
    criteria: IdSchema,
    direction: CriteriaDirectionSchema,
});
export const ProcessAreaCriteriaAssociationMutationResourceSchema = getMutationSchema(
    ProcessAreaCriteriaAssociationResourceSchema
);

export type ProcessAreaCriteriaAssociationResource = z.infer<typeof ProcessAreaCriteriaAssociationResourceSchema>;

export const defaultProcessAreaCriteriaAssociationResource: ProcessAreaCriteriaAssociationResource = {
    ...defaultIndirectlyVersionedArtifactResource,
    resourceType: ResourceType.PROCESS_AREA_CRITERIA_ASSOCIATION,
    criteria: '',
    direction: CriteriaDirection.ENTER,
};

export function useProcessAreaCriteriaAssociationActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/process-area-criteria-association',
            ResourceType.PROCESS_AREA_CRITERIA_ASSOCIATION,
            ProcessAreaCriteriaAssociationResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/process-area-criteria-association',
            ResourceType.PROCESS_AREA_CRITERIA_ASSOCIATION,
            ProcessAreaCriteriaAssociationResourceSchema
        ),
    };
}
